export default __webpack_public_path__ + "static/media/primaryBigArrow.82733b6e.svg";